import { render, staticRenderFns } from "./front-urgentorder-list.vue?vue&type=template&id=3dcb9472&"
import script from "./front-urgentorder-list.vue?vue&type=script&lang=ts&"
export * from "./front-urgentorder-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports